import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'

import {http} from 'hiya-common/src/utils/axios'

import {useSelector} from 'react-redux'
import {
  IDoLotteryResp,
  ILotteryPrizeItem,
  ILotteryRankResp,
  ILotteryResp,
  IRankItem,
  IRewardRecord,
  IRwardItem,
  ITopPrizeItem,
} from './type'

export const lottery_info = createAsyncThunk(
  '/live/gift/lottery_info',
  async (arg, store: any) => {
    const resp = await http.post<HiyaRes<ILotteryResp>>(
      '/live/gift/lottery_info',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

export type IDoLotteryReq = {
  /** int64	房间id	*/
  room_id: number
  /** int64	抽奖次数	*/
  lottery_times: 1 | 10 | 50
}
/** /live/gift/do_lottery */
export const do_lottery = createAsyncThunk(
  '/live/gift/do_lottery',
  async (params: IDoLotteryReq, store: any) => {
    const resp = await http.post<HiyaRes<IDoLotteryResp>>(
      '/live/gift/do_lottery',
      {
        ...store.getState().env.deviceinfo,
        ...params,
      }
    )
    return resp.data.data
  }
)

export type ILotteryRankReq = {
  /** 页偏移量，第一页为空 */
  offset?: string
  /** 周期索引  0-本周  -1=上周 */
  period_index?: number
}
export const lottery_rank = createAsyncThunk(
  '/live/gift/lottery_rank',
  async ({offset = '', period_index = 0}: ILotteryRankReq, store: any) => {
    const resp = await http.post<HiyaRes<ILotteryRankResp>>(
      '/live/gift/lottery_rank',
      {
        ...store.getState().env.deviceinfo,
        offset,
        period_index,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// /live/account/profile
export const account_profile = createAsyncThunk(
  '/live/account/profile',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<{
        diamonds: number
        diamonds_display: number
      }>
    >('/live/account/profile', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

interface InitialStateType {
  latest_reward_list: IRewardRecord[]
  prize_list: ILotteryPrizeItem[]
  lottery_cost: number
  lottery_cost_display: number

  has_more: boolean
  rank_list: IRankItem[]
  own_rank: IRankItem
  next_offset: string

  lottery_status: number
  reward_content: IRankItem[]

  latestLotteryTimes: 1 | 10 | 50

  /* 当前点击用户中奖信息 */
  currentRecord: IRankItem

  topn_prizes: ITopPrizeItem[]
  rank_end_time: number
  diamonds: number
  diamonds_display: number
}

const initialState: InitialStateType = {
  latest_reward_list: [],
  prize_list: [],
  lottery_cost: 0,
  lottery_cost_display: 0,
  has_more: false,
  rank_list: [],
  own_rank: {
    mid: 0,
    avatar: '',
    username: '',
    lucky_val: 0,
    lucky_val_display: 0,
    rank: 0,
    reward_list: [],
  },
  next_offset: '',
  lottery_status: 0,
  reward_content: [],
  latestLotteryTimes: undefined,
  currentRecord: {} as IRankItem,

  topn_prizes: [],
  rank_end_time: 0,
  diamonds: 0,
  diamonds_display: 0,
}

export const FamilyEggMachineSlice = createSlice({
  name: 'FamilyEggMachine',
  initialState,
  reducers: {
    setLatestLotteryTimes: (state, action) => {
      Object.assign(state, {
        latestLotteryTimes: action.payload,
      })
    },
    setCurrentRecord: (state, action) => {
      Object.assign(state, {currentRecord: {...action.payload}})
    },
  },
  extraReducers: (builder) => {
    builder.addCase(lottery_info.fulfilled, (state, action) => {
      const {
        latest_reward_list,
        prize_list,
        lottery_cost,
        lottery_cost_display,
      } = action.payload
      Object.assign(state, {
        latest_reward_list,
        prize_list,
        lottery_cost,
        lottery_cost_display,
      })
    })
    builder.addCase(do_lottery.fulfilled, (state, action) => {
      const {lottery_status, reward_content} = action.payload
      Object.assign(state, {
        lottery_status,
        reward_content,
      })
    })
    builder.addCase(lottery_rank.fulfilled, (state, action) => {
      const {
        has_more,
        rank_list,
        own_rank,
        next_offset,
        topn_prizes,
        rank_end_time,
      } = action.payload
      Object.assign(state, {
        has_more,
        rank_list,
        own_rank,
        next_offset,
        topn_prizes,
        rank_end_time,
      })
    })

    builder.addCase(account_profile.fulfilled, (state, action) => {
      const {diamonds, diamonds_display} = action.payload
      Object.assign(state, {
        diamonds,
        diamonds_display,
      })
    })
  },
})
export default FamilyEggMachineSlice.reducer
export const FamilyEggMachineActions = FamilyEggMachineSlice.actions

export const useFamilyEggMachineState = () =>
  useSelector((state) => {
    return state.FamilyEggMachineSlice
  })
